import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { applyTheme, getTheme } from "../../theme";

export default function ThemeToggle() {
  const { t } = useTranslation();
  const [theme, setTheme] = useState(getTheme);
  const isLight = theme === "light";

  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(getTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-theme"] });
    return () => observer.disconnect();
  }, []);

  const toggle = () => setTheme(applyTheme(isLight ? "dark" : "light"));

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={isLight ? t("nav.themeDark") : t("nav.themeLight")}
      title={isLight ? t("nav.themeDark") : t("nav.themeLight")}
    >
      <svg className="moon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
      </svg>
      <svg className="sun" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
      </svg>
    </button>
  );
}
